import { HedgeControlStatusEnum } from '@talos/kyoko';
import {
  BLOTTER_ID_ALL_STATUS,
  BLOTTER_ID_ERROR_STATUS,
  BLOTTER_ID_HEDGING_STATUS,
  BLOTTER_ID_WAITING_STATUS,
} from './tokens';
import type { HedgePositionStatusTabProps } from './types';

export const HEDGE_POSITION_STATUS_TABS_EXCLUDED_IDS = [
  BLOTTER_ID_ALL_STATUS,
  BLOTTER_ID_ERROR_STATUS,
  BLOTTER_ID_HEDGING_STATUS,
  BLOTTER_ID_WAITING_STATUS,
];

export const DEFAULT_HEDGE_POSITION_STATUS_TABS: HedgePositionStatusTabProps[] = [
  {
    label: 'All',
    id: BLOTTER_ID_ALL_STATUS,
    defaultFilter: {},
  },
  {
    label: 'Error',
    id: BLOTTER_ID_ERROR_STATUS,
    defaultFilter: {
      HedgeControlStatus: [HedgeControlStatusEnum.Error],
    },
  },
  {
    label: 'Hedging',
    id: BLOTTER_ID_HEDGING_STATUS,
    defaultFilter: {
      HedgeControlStatus: [HedgeControlStatusEnum.Hedging],
    },
  },
  {
    label: 'Waiting',
    id: BLOTTER_ID_WAITING_STATUS,
    defaultFilter: {
      HedgeControlStatus: [HedgeControlStatusEnum.Waiting],
    },
  },
];
